<template>
  <b-col cols="12" md lg="6" sm="12" order="1" order-md="0">
    <div
      class="text-azul-medio text-uppercase gilmer h5 text-center mt-md-4 font-weight-light"
    ></div>
    <div
      class="h6 text-center rounded text-white px-0 bg-azul-medio w-100 py-3"
    >
      <b-row>
        <b-col cols="12" lg="12">
          <div class="gilmer text-uppercase h5 mx-3 mx-lg-6 mt-4">
            <b>¿QUÉ ES EL SISTEMA DE ADMISIÓN ESCOLAR?</b>
          </div>
          <div class="form-group mx-4 mt-4 text-justify m-1 h5">
            <span class="d-block mb-2">
              Es el mecanismo oficial para postular a establecimientos públicos
              y particulares subvencionados en Chile.
            </span>
            <span class="d-block mb-2 resalta text-justify">
              Podrás postular entre el {{ inicioPostulacion }} y el
              {{ finPostulacion }}.
            </span>
            <span class="d-block mb-2">
              Revisa con atención las fechas de postulación, resultados y
              matrícula de Admisión Escolar {{ anioAdmision }}.
            </span>
          </div>
        </b-col>

        <b-col cols="12" lg="12">
          <div class="form-group mx-4 mt-2 text-justify m-1 h5">
            <p class="d-block mb-2">
              Aquí podrás conocer todos los colegios disponibles para postular:
            </p>
          </div>
          <div class="form-group mx-4 mx-lg-5 mt-3 text-center">
            <router-link
              data-testid="button-ver-establecimientos"
              :to="{ name: 'Vitrina' }"
              class="btn-lg btn-azul-oscuro2 text-uppercase gilmer font-weight-bold w-100"
              type="submit"
              >VER ESTABLECIMIENTOS</router-link
            >
          </div>
        </b-col>
        <b-col cols="12" lg="12">
          <div class="form-group mx-4 mt-1 text-justify m-1 h5">
            <p class="d-block mb-2">
              Utiliza los filtros por comuna, nivel, jornada u otros criterios
              para encontrar las mejores opciones para ti.
            </p>
          </div>
          <div class="form-group mx-4 mt-2 text-justify m-1 h5">
            <p class="d-block mb-2">
              Tómate el tiempo necesario para revisar las características de
              cada establecimiento antes de postular.
            </p>
          </div>
          <div class="form-group mx-4 mt-2 text-center m-1 h5">
            <p class="d-block mb-2">
              Para más información, visita:
              <a
                class="no-hover-color"
                href="https://www.sistemadeadmisionescolar.cl"
                target="_blank"
                >www.sistemadeadmisionescolar.cl</a
              >
            </p>
          </div>
        </b-col>
      </b-row>
    </div>

    <InformacionAceptaCondiciones />
  </b-col>
</template>

<script>
import InformacionAceptaCondiciones from "@/components/login/InformacionAceptaCondiciones";
export default {
  components: {
    InformacionAceptaCondiciones
  },
  name: "InformacionPostulacion",
  data() {
    return {
      ayuda: PLATAFORMA.AYUDA,
      anioPostulacion: "",
      anioAdmision: ""
    };
  },
  created() {
    const obtenerValorLocalStorage = (key, valorPorDefecto = "----") => {
      const valor = localStorage.getItem(key);
      return valor ? valor : valorPorDefecto;
    };

    this.anioPostulacion = obtenerValorLocalStorage("anioPostulacion");
    this.anioAdmision = obtenerValorLocalStorage("anioAdmision");
    this.inicioPostulacion = obtenerValorLocalStorage("inicioPostulacion");
    this.finPostulacion = obtenerValorLocalStorage("finPostulacion");
  }
};
</script>

<style scoped>
.inicial {
  text-align: initial;
}
</style>



// WEBPACK FOOTER //
// src/components/login/InformacionPostulacion.vue